import { render, staticRenderFns } from "./PrimaryCareInsurancePage.vue?vue&type=template&id=4a37963a&scoped=true"
import script from "./PrimaryCareInsurancePage.vue?vue&type=script&lang=js"
export * from "./PrimaryCareInsurancePage.vue?vue&type=script&lang=js"
import style0 from "./PrimaryCareInsurancePage.vue?vue&type=style&index=0&id=4a37963a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a37963a",
  null
  
)

export default component.exports